import { render, staticRenderFns } from "./Cupons.vue?vue&type=template&id=5f7ccb76"
import script from "./Cupons.vue?vue&type=script&lang=ts"
export * from "./Cupons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports